import { render, staticRenderFns } from "./ButtonColor.vue?vue&type=template&id=bd9d1f04&scoped=true"
import script from "./ButtonColor.vue?vue&type=script&lang=js"
export * from "./ButtonColor.vue?vue&type=script&lang=js"
import style0 from "./ButtonColor.vue?vue&type=style&index=0&id=bd9d1f04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9d1f04",
  null
  
)

export default component.exports